import {getLegendItems} from '../../../../../selectors/seating/legend'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {LegendOwnProps, LegendRuntimeProps} from './interfaces'
import {Legend as Presentation} from './legend'

const mapRuntime = (
  {state, actions: {seatingMapButtonClick}}: DetailsPageAppProps,
  {t, getFormattedMoney, getTicketPriceText}: LegendOwnProps,
): LegendRuntimeProps => ({
  legendItems: getLegendItems(state, t, {getTicketPriceText, getFormattedMoney}),
  seatingMapButtonClick,
})

export const Legend = connect<LegendOwnProps, LegendRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
